import { NAV_ITEMS, NOTIFICATIONS_ITEM, PROFILE_ITEM } from '../components/layout/navigation';
import type { ScreenId } from '../components/layout/navigation';

/**
 * Caminho de cada tela. O dashboard é a raiz e as demais usam o próprio id —
 * uma tabela de tradução (`/linhas`, `/contas`…) daria endereços mais bonitos ao
 * custo de uma segunda lista de telas para manter em sincronia com a navegação.
 */
export function screenPath(screen: ScreenId): string {
  return screen === 'dashboard' ? '/' : `/${screen}`;
}

const SCREENS: ScreenId[] = [...NAV_ITEMS, NOTIFICATIONS_ITEM, PROFILE_ITEM].map(
  (item) => item.id,
);

/** Caminho fora da lista cai no dashboard — inclusive `/` e a raiz com barras. */
export function screenFromPath(pathname: string): ScreenId {
  const slug = pathname.replace(/^\/+|\/+$/g, '');

  return SCREENS.find((screen) => screen === slug) ?? 'dashboard';
}
